/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-fluid[_ngcontent-%COMP%]{background-color:#fff}.title[_ngcontent-%COMP%]{color:#003479}a[_ngcontent-%COMP%]{cursor:pointer;font-size:smaller;color:#2a6ebb!important}a[_ngcontent-%COMP%]:hover{text-decoration:underline!important}h4[_ngcontent-%COMP%]{font-weight:600;margin-top:.5rem}ul[_ngcontent-%COMP%]{list-style:none}p[_ngcontent-%COMP%]{font-size:18px}.link-image[_ngcontent-%COMP%]{border-width:0;border-style:none;padding-top:5px;padding-right:5px}"];
export { styles as styles };
